import { boAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  location: null,
  coverage: { nodeid: '', hasCoverage: false },
};

export const locationDetails = {
  state: { ...initialState },
  reducers: {
    updateLocation(state, payload) {
      return { ...state, location: payload };
    },
    updateCoverage(state, payload) {
      return { ...state, coverage: payload };
    },
  },
  effects: (dispatch) => {
    return {
      async checkCoverage({ latitude, longitude, callBack = null }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          mathod: 'GET',
          url: boAPI.checkCoverage,
          params: {
            'geolocation.latitude': latitude,
            'geolocation.longitude': longitude,
          },
        })
          .then(({ data }) => {
            dispatch.apiStatus.setProcessing(false);
            dispatch.locationDetails.updateCoverage(data['coverage']);
            const hasCoverage = data['coverage']['hasCoverage'] === 'true';
            return { success: true, hasCoverage, data };
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Check Coverage',
                boAPI.checkCoverage,
                'Check Coverage API'
              ),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Check Coverage API') });
            return { success: false };
          });
      },
    };
  },
};
